<template>
    <vContactComponent :postList="postList" v-if="flag"></vContactComponent>
</template>
<script>
import vContactComponent from '../../listComponent/basicdata/contact/contactComponent.vue';
export default {
    name: 'contactList',
    components: {
        vContactComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                code: true,
                name: true,
                province_rid: true,
                city_rid: true,
                entity_name: true,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>